<div class="row">
    <div class="col-12">
        <div class="checkbox">
            <label>
                <input
                    type="checkbox"
                    [(ngModel)]="entity.active"
                    (ngModelChange)="onActiveChange()"
                />
                Generate Code
            </label>
        </div>
    </div>
    <div class="col-12 col-lg-9">
        <div *ngIf="entity.active">
            <label class="form-control-label">Next code will be:</label>
        </div>
        <div *ngIf="entity.active">
            <input
                type="text"
                class="form-control"
                [disabled]="true"
                [(ngModel)]="entity.nextCode"
            />
        </div>
    </div>
    <div class="col-12 col-lg-3">
        <div
            class="btn-group text-end clearfix {{
                entity.active ? '' : 'no-margin'
            }}"
        >
            <button
                type="submit"
                (click)="submit()"
                [disabled]="form.invalid && entity.active"
                class="btn btn-primary pull-right"
            >
                Save
            </button>
        </div>
    </div>
</div>
<form class="formly" role="form" [formGroup]="form" (ngSubmit)="submit()">
    <formly-form [model]="entity" [fields]="fields" [form]="form">
    </formly-form>
</form>
